import {NgModule} from '@angular/core'
import {FormModule} from './form/form.module'
import {JsonpModule} from '@angular/http'
import {CoreModule} from './core/core.module'
import {SharedModule} from './shared/shared.module'
import {FormEditorComponent} from './form-editor.component'
import {DragulaModule} from 'ng2-dragula'

@NgModule({
  declarations: [FormEditorComponent],
  exports: [FormEditorComponent],
  imports: [
    FormModule,
    CoreModule.forRoot(),
    SharedModule,
    JsonpModule,
    DragulaModule.forRoot(),
  ],
})
export class FormEditorModule {
}
